import { getRegions } from '../services/restaurant';
import { MODEL_TYPE, PRICE_CALCULATION_MODE } from '../utils/enums';
import {fixedNumber} from "../utils/math-util.js";

export function courierDeliveryFeesModel(data) {
    const objData = {...(data || {})};
    const regions = getRegions();

    if(!objData.useAbsValueForOrderCountPriceChange) {
        objData.orderCountPriceChangeIncrement = fixedNumber(objData.orderCountPriceChangeIncrement * 100, 2);
    }

    return {
        calculationMode: objData.calculationMode || PRICE_CALCULATION_MODE.fixedRegionBased,
        basisPrice: objData.basisPrice || 0,
        maxDeliveryPrice: objData.maxDeliveryPrice || 0,
        pricePerKm: objData.pricePerKm || 0,
        basisDistanceInMeters: objData.basisDistanceInMeters || 0,
        regionConfigurations: (objData.regionConfigurations || new Array(0)).map(regionConfiguration=> {
            const region = regions.find(f=> f.id === regionConfiguration.regionId) || {};

            return {
                ...regionConfiguration,
                id: region.id || regionConfiguration.regionId,
                name: region.name || ""
            }
        }),
        minOrderCountToApplyPriceChange: objData.minOrderCountToApplyPriceChange || 0,
        orderCountPriceChangeIncrement: objData.orderCountPriceChangeIncrement || 0,
        useAbsValueForOrderCountPriceChange: objData.useAbsValueForOrderCountPriceChange || false,
        id: objData.id || null,
        name: objData.name || null,
        modelType: MODEL_TYPE.courierDeliveryFees,
        doNotAllowCycleReject: objData.doNotAllowCycleReject || false,
        excludeFromAutomation: objData.excludeFromAutomation || false,
        isPriorityAssignment: objData.isPriorityAssignment || false

    };
}

export function courierDeliveryFeesServerModel(data) {
    const objData = {...(data || {})};

    if(!objData.useAbsValueForOrderCountPriceChange) {
        objData.orderCountPriceChangeIncrement = fixedNumber(objData.orderCountPriceChangeIncrement / 100, 2);
    }

    const body = {
        MinOrderCountToApplyPriceChange: objData.minOrderCountToApplyPriceChange || 0,
        OrderCountPriceChangeIncrement: objData.orderCountPriceChangeIncrement || 0,
        UseAbsValueForOrderCountPriceChange: objData.useAbsValueForOrderCountPriceChange || false,
        CalculationMode: objData.calculationMode || PRICE_CALCULATION_MODE.fixedRegionBased,
        BasisPrice: objData.basisPrice || 0,
        MaxDeliveryPrice: objData.maxDeliveryPrice || 0,
        DeliveryPrice: objData.deliveryPrice || 0,
        PricePerKm: objData.pricePerKm || 0,
        Name: objData.name || null,
        BasisDistanceInMeters: objData.basisDistanceInMeters || 0,
        RegionConfigurations: (objData.regionConfigurations || []).map(val => ({
            RegionId: val.id || val.regionId,
            DeliveryPrice: val.deliveryPrice || 0,
            ApplyToBothDirections: val.applyToBothDirections || false,
            SourceRegionId: val.sourceRegionId || null,
        })),
        DoNotAllowCycleReject: objData.doNotAllowCycleReject || false,
        ExcludeFromAutomation: objData.excludeFromAutomation || false,
        IsPriorityAssignment: objData.isPriorityAssignment || false

    };

    if(objData.id) {
        body.Id = objData.id;
    }

    return body;
}